import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const assetCostModelCrud = (data?: any) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `asset-cost-model/forecast/generator`,
    data
  );
};
export const assetCostModelHeaderCrud = (data?: any) => {
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `asset-cost-model/header/edit`,
    data
  );
};
export const assetCostModelStatistic = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `asset-cost-model/statistic/get`
  );
};
